import React, { useEffect, useState, useRef } from 'react';
import { notification, Popover, Modal, Button, Space, Skeleton } from 'antd';
import Table from 'components/Table';
import { useSelector } from 'react-redux';
import '../style.css';
import { useQuery } from 'react-query';
import { ReloadOutlined, ScheduleOutlined } from '@ant-design/icons';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { PageHeader } from '../../../components/Atom/PageHeader';
import { ResetButton, FilterButton } from '../../../components/Atom/Button';
import SearchField from '../../../components/Atom/SearchField/index';
import { getAllSubscription, getSingleSubscription } from 'api/subscriptions';
import { TIMEZONES } from 'utils/constant';
import Filter from './assets/filter';
import { convertToSubscriptionTimezone, checkUserPermissions, handleDateRangeFormat, formatAmount, handleStateByPassData } from 'utils/services';
import { USER_ROLES } from 'utils/constant';
import CreateSubscription from './createSubscription';
import StatusTag from '../../../components/Atom/StatusTag';
import { useNavigate, useLocation } from 'react-router-dom';
import ShortenId from 'components/Atom/ShortenId';
export const Subscription = () => {
  const [filterToggle, setFilterToggle] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [subsModalData, setSubsModalData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [recordId, setRecordId] = useState('');
  const [delayTimer, setDelayTimer] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const tableContainerRef = useRef(null);
  const store = useSelector((state) => state?.company?.store);

  const fetchSubsData = async (subscriptionData) => {
    setDataLoading(true);
    const response = await getSingleSubscription(subscriptionData?.store_id, subscriptionData?.subscription_id);
    const data = response?.data?.data;
    setSubsModalData(data);
    setDataLoading(false);
  };

  const handleOpen = () => {
    setOpen(!open);
    setIsEdit(false);
  };
  const columnsData = [
    {
      title: 'Subscription ID',
      render: (value) => <ShortenId value={value?.subscription_id} />,
      key: 'subscription_id',
      fixed: 'left',
      width: 200,
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.state} />,
      key: 'state',
    },
    {
      title: 'Email/Phone',
      render: (value) => value?.customer?.email || value?.customer?.phone || '-',
      key: 'email',
    },
    {
      title: 'Price',
      render: (value) => `${value?.payment?.currency || ''} ${formatAmount(value?.payment?.amount || '0', value?.payment?.currency)}`,
      key: 'amount',
    },
    {
      title: 'Time',
      render: (value) => value?.updatedAt,
      key: 'updatedAt',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (subscriptionData, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <>
                    <div
                      className='table-action-btn flex items-center justify-center'
                      onClick={() => {
                        fetchSubsData(subscriptionData);
                        setOpen(true);
                        setIsEdit(true);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Update
                    </div>
                  </>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const [search, setSearch] = useState('');

  const fetchData = async (queryParams) => {
    try {
      const paramsData = { offset: queryParams?.offset, limit: queryParams?.limit };
      if (queryParams?.search !== '') {
        paramsData['search_key'] = queryParams?.search;
      }
      const formattedData = filtersDataValues(queryParams?.filtersData);
      const params = { ...paramsData, ...formattedData, ...(store?.isSelected && { store_id: store?._id }), xap_request: true };
      const response = await getAllSubscription(params);
      const timezone = store?.settings?.timezone || TIMEZONES?.PKT;
      const result = await convertToSubscriptionTimezone(response?.data?.data, timezone, 'subscriptions');
      response.data.data = result;
      return response?.data?.data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data, refetch, isLoading, isFetching } = useQuery('subscriptions', () => fetchData(queryParams), {
    enabled: false,
    manual: true,
  });
  const [queryParams, setQueryParams] = useState({
    offset: 0,
    limit: 20,
    search: '',
    currentPage: 1,
  });
  const [trigerApi, setTrigerApi] = useState(true);
  useEffect(() => {
    if (location?.state?.isRedirection && data) {
      setSearch(location?.state?.searchValue);
      setRecordId(location?.state?.id);
      navigate(location.pathname, { replace: true });
      const data = handleStateByPassData(location?.state?.filtersData, true);
      if (!data) {
        refetch();
      }
      setQueryParams(data);
      setTimeout(() => {
        if (tableContainerRef?.current && location?.state?.id) {
          const row = document?.querySelector(`.custom-row-class.highlighted-row`);
          if (row) {
            row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }, 10);
      return;
    } else if (location?.state?.isRedirection) {
      navigate(location.pathname, { replace: true });
    }
    refetch();
  }, [trigerApi, store]);
  const filtersDataValues = (data) => {
    let filtersData = {};
    if (data?.date_range) {
      const timezone = store?.isSelected ? store?.settings?.timezone || TIMEZONES.PKT : null;
      const { start_date, end_date } = handleDateRangeFormat(data?.date_range, timezone);
      filtersData.start_date = start_date;
      filtersData.end_date = end_date;
    }
    filtersData.status = data?.subscription_status ?? null;
    return filtersData;
  };
  const getSearch = async (e) => {
    if (e === '' || e == null) {
      notification?.error({ message: 'Please enter details for search', placement: 'bottomRight' });
    } else {
      setQueryParams((pre) => ({ ...pre, currentPage: 1, offset: 0, search: e }));
      setTrigerApi(!trigerApi);
    }
  };
  const handlePagePageChange = (page, pageSize) => {
    if (queryParams?.limit !== pageSize) {
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: 0, currentPage: 1 }));
      setTrigerApi(!trigerApi);
    } else {
      const countOffset = page * queryParams?.limit - queryParams?.limit;
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: countOffset, currentPage: page }));
      setTrigerApi(!trigerApi);
    }
  };
  const handleFileSelectionModel = () => {
    if (store?.isSelected) {
      setOpen(true);
    } else {
      notification.error({
        message: 'Store Selection Required',
        description: 'Please select a store from the drop-down menu above to continue',
        placement: 'bottomRight',
      });
    }
  };
  const handleSearchData = () => {
    if (delayTimer) {
      clearTimeout(delayTimer);
    }
    const newTimer = setTimeout(() => {
      handleRefresh();
    }, 1500);
    setDelayTimer(newTimer);
  };
  const handleRefresh = (isRefresh = true) => {
    if (isRefresh) {
      setSearch(null);
    } else {
      setIsFilterModalOpen(false);
    }
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, search: '', filtersData: isRefresh ? pre?.filtersData : null }));
    setTrigerApi(!trigerApi);
  };
  const handleCloseFilterModel = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  const handleFiltersSearch = (data) => {
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, filtersData: data }));
    setTrigerApi(!trigerApi);
  };
  const filterToggler = () => {
    setFilterToggle(true);
  };
  const handleReset = () => {
    setQueryParams((prev) => ({ ...prev, offset: 0, currentPage: 1, filtersData: {} }));
    setTrigerApi(!trigerApi);
    setIsFilterModalOpen(false);
  };

  const popOverContent = (
    <div className='popOver'>
      <div className='popover_header mt-2 mb-3 flex items-center gap-2'>
        <span style={{ fontWeight: '700', color: '#262626' }}>Filter</span>
        <div className='flex items-center text-[#000000] gap-2 cursor-pointer' onClick={() => handleReset()}>
          <ReloadOutlined style={{ fontSize: '16px' }} />
          <span style={{ color: '#000000', fontSize: '14px', lineHeight: '24px' }}>Reset All</span>
        </div>
      </div>
      <div className='intentFilters'>
        <Filter filterToggler={filterToggler} filtersData={queryParams?.filtersData} onSearch={handleFiltersSearch} handleClose={handleCloseFilterModel} />
      </div>
    </div>
  );
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Subscriptions',
      },
    ],
  };
  const handleSearch = (e) => {
    if (delayTimer && e !== '' && e !== null) {
      clearTimeout(delayTimer);
    }
    setSearch(e?.target?.value?.trim());
  };
  const handleRowHover = () => {
    setRecordId('');
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container'>
        <Breadcrumbs {...breadcrumbProps} />
        <div className='headerPage'>
          <div className=''>
            <PageHeader label='Subscriptions' button={<ResetButton onClick={isFetching ? '' : handleRefresh} loading={isFetching} />} />
          </div>
          {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_SUBSCRIPTION_USER]) && (
            <div>
              <Button className='primaryBtn mr-0 mb-0 rounded-lg' onClick={handleFileSelectionModel}>
                <span className='text-base'>Create Subscription</span>
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className='actionPanel'>
        <div className='headerContainer' style={{ width: '100%' }}>
          <Popover
            className={isFilterModalOpen ? 'filter-active filterPopover' : filterToggle ? 'text-base activeFilterToggler filterPopover' : 'text-base filterPopover'}
            trigger='click'
            placement='bottomLeft'
            content={popOverContent}
            open={isFilterModalOpen}
            destroyTooltipOnHide
            onOpenChange={() => {
              handleCloseFilterModel();
            }}>
            <FilterButton onClick={() => setIsFilterModalOpen(true)}>
              <div className='text-base'>Filter</div>
            </FilterButton>
          </Popover>
          <div className='searchInput' style={{ width: '100%' }}>
            <SearchField
              handleOnChange={handleSearch}
              value={search}
              handlePressEnter={getSearch}
              onReset={handleSearchData}
              placeholder={'Search by Subscription ID, Plan ID, Token ID, Email, Phone, Currency, Interval'}
              loading={!!(isFetching && search)}
              dropdown={{ show: false }}
              enableSearchBtn={true}
            />
          </div>
        </div>
      </div>
      <br />
      <div className='overflow-x-auto custom-table' ref={tableContainerRef}>
        <Table
          loading={isLoading}
          dataSource={data?.products}
          columns={columnsData}
          scroll={{ x: 'auto' }}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const { className } = event?.target;
                if (!className?.includes('table-action-btn')) {
                  navigate(`/subscriptions/${record?.subscription_id}`, {
                    state: {
                      record,
                      id: record?.subscription_id,
                      searchValue: search,
                      filtersData: handleStateByPassData(queryParams),
                    },
                  });
                }
              },
              onMouseEnter: handleRowHover,
              className: `custom-row-class ${recordId === record?.subscription_id ? 'highlighted-row' : ''}`,
            };
          }}
          totalLenght={data?.count}
          pagingation={{ handlePageChange: handlePagePageChange, perPageSize: queryParams?.limit, page: queryParams?.currentPage }}
        />
      </div>
      <Modal trigger='click' centered open={open} width={window.innerWidth < 768 ? 350 : 600} footer={null} destroyOnClose onCancel={handleOpen}>
        <div className='mobileVersion'>
          <div className='font-semibold text-base' style={{ marginBottom: '12px' }}>
            <span className='createIcon'>
              <ScheduleOutlined />
            </span>
          </div>
          <div className='font-semibold text-base' style={{ marginBottom: '12px' }}>
            {!isEdit ? 'Add new Subscription' : 'Update Subscription'}
          </div>
          {dataLoading ? (
            <div style={{ width: '100%' }}>
              <Skeleton active />
            </div>
          ) : (
            <CreateSubscription handleOpen={handleOpen} refetch={refetch} subscriptionData={subsModalData} isEdit={isEdit} />
          )}{' '}
        </div>
      </Modal>
    </div>
  );
};
